import { render } from "./UIIcon.vue?vue&type=template&id=1cee4396&scoped=true&ts=true"
import script from "./UIIcon.vue?vue&type=script&lang=ts"
export * from "./UIIcon.vue?vue&type=script&lang=ts"

import "./UIIcon.vue?vue&type=style&index=0&id=1cee4396&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cee4396"]])

export default __exports__